/**
 * Shown in footer and admin chrome. Set at build time via VITE_APP_VERSION
 */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION?.trim() || "2.5.96";
